import { generateRandomLogin } from '../generateRandomLogin';
import { emailDomainBase } from '../lib';
import { getRandomElementFromArray } from '../../../../../utils';

export function generateRandomEmail(): string {
    return `${generateRandomLogin()}@${getRandomElementFromArray(emailDomainBase)}`;
}
